import { QueryClient as ReactQueryClient } from '@tanstack/react-query'

export type QueryClient = ReactQueryClient

export const queryClient = new ReactQueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000, // Thirty seconds
    },
  },
})
